import React, {useState, useEffect} from 'react';
import {goToPage, createStandAloneSale, setError, reportDWH} from '../StandAlonePurchaseSaleSlice';
import {showAppLoader, hideAppLoader} from '../../../Shared/Loader/LoaderSlice';
import {ePages} from '../Constants';
import BtnSubmit from '../../../Shared/Buttons/BtnSubmit';
import StandAloneSaleAlmostDone from '../StandAloneSaleAlmostDone/StandAloneSaleAlmostDone';
import {connect} from 'react-redux';

const CheckoutPage = (props) => {
  // TODO: CREATE ORDER WHEN FINISHED
  const [isAlmostDoneFromSubmit, setIsAlmostDoneFromSubmit] = useState(false);

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  async function createStandAloneSaleAsync() {
    try {
      const personalInfo = {
        firstName: props.personalInfo.firstName,
        lastName: props.personalInfo.lastName,
        id: props.personalInfo.IDNumber,
        email: props.form.email,
        ban: props.ban,
      };
      const isDeliveryFree =
        props.deliveryCost === '' ||
        props.deliveryCost === '0' ||
        parseInt(props.productQuantity) >= parseInt(props.minQuantityForFreeDelivery);

      const isProductFree = props.productPrice === '' || props.productPrice === '0';

      const standAloneSale = {
        selectedAddress: props.form,
        personalInfo: personalInfo,
        selectedDeliverySlot: props.selectedDeliverySlot,
        otpPhone: props.isOtpPhoneEdited && props.isOtpPhoneValid ? props.otpPhoneEdited : props.form.phone,
        deliveryCost: isDeliveryFree ? '0' : props.deliveryCost,
        productId: props.productToPurchaseId,
        productPrice: isProductFree ? '0' : props.productPrice,
        productQuantity: props.productQuantity,
        productName: props.productName,
      };

      console.info('createStandAloneSale', JSON.stringify(standAloneSale));
      props.showAppLoader();
      const result = await props.createStandAloneSale(standAloneSale);
      props.hideAppLoader();
      console.info('createStandAloneSale', result);
      const isSuccess = result.payload.Header.ReturnCode == 0 && result.payload.Body.isSuccess;
      if (!isSuccess) {
        props.reportDWH({
          actionType: 'Finish Page Btn Click',
          statusText: 'Error',
          messageText: 'General Error',
        });
        if (result.payload.Body.codeError == '94') {
          props.setError({isDisplay: true, id: 13, isOpenWorkOrder: true});
        } else {
          makeSaleShowError(result.Header.ReturnCode);
        }
      }
      props.reportDWH({
        actionType: 'Finish Page Btn Click',
        statusText: 'Completed',
        messageText: 'Order Succeeded',
      });
      props.goToPage({page: ePages.SUCCESS_PAGE, percent: '100'});
    } catch (error) {
      console.info('makeSale', error);
      makeSaleShowError(error.errorCode);
    } finally {
      props.hideAppLoader();
    }
  }

  function makeSaleShowError(errorCode) {
    switch (errorCode) {
      case 57:
      case 58:
      case 59:
      case 60:
        props.setError({isDisplay: true, id: errorCode, isOpenWorkOrder: true});
        break;
      default:
        props.setError({isDisplay: true, id: 14, isOpenWorkOrder: true});
    }
  }

  function handleCheckOutValidation(isValid) {
    if (isValid) {
      if (props.isOtpPhoneEdited && props.isOtpPhoneValid) {
        props.reportDWH({
          actionType: 'Finish Page Contact Phone Update',
          statusText: 'Ongoing',
          messageText: 'Contact Phone Updated',
          param1: props.otpPhoneEdited,
        });
      }
      createStandAloneSaleAsync();
    }
    setIsAlmostDoneFromSubmit(false);
  }

  return (
    <div className='checkout-page'>
      <span className='checkout-page__title'>כבר מסיימים</span>
      <StandAloneSaleAlmostDone isSubmit={isAlmostDoneFromSubmit} onValid={handleCheckOutValidation} />
      <BtnSubmit
        text={props.checkoutPageButtonText === '' ? 'הזמן' : props.checkoutPageButtonText}
        onclick={() => setIsAlmostDoneFromSubmit(true)}
      />
    </div>
  );
};
const mapStateToProps = (state) => {
  return {
    productToPurchaseId: state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.productToPurchaseId?.value ?? '',
    checkoutPageButtonText: state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.checkoutPageButtonText?.value ?? '',
    productQuantity: state.standAlonePurchaseSaleBlock?.productQuantity,
    selectedDeliverySlot: state.standAlonePurchaseSaleBlock?.selectedDeliverySlot,
    productName: state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.productToPurchaseTitle.value ?? '',
    minQuantityForFreeDelivery:
      state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.productMinQuantityForCancellingDeliveryCost.value ?? '',
    productPrice: state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.productToPurchasePrice?.value ?? '',
    deliveryCost: state.standAlonePurchaseSaleBlock?.epiContent?.iContent?.deliveryCost.value ?? '',
    form: state.standAlonePurchaseSaleBlock?.form,
    flowType: state.standAlonePurchaseSaleBlock?.flowType,
    ban: state.standAlonePurchaseSaleBlock?.tvProducts.filter((prd) => prd.chosenSubscription === true)[0].ban ?? '',
    isOtpPhoneEdited: state.almostDone?.phoneIsEdit,
    isOtpPhoneValid: state.almostDone?.form.valid ?? '',
    otpPhoneEdited: state.almostDone?.form.phone ?? '',

    //other state
    personalInfo: state.authentication?.loginData?.userDetails ?? '',
  };
};

const mapDispatchToProps = {
  goToPage,
  showAppLoader,
  hideAppLoader,
  createStandAloneSale,
  setError,
  reportDWH,
};

export default connect(mapStateToProps, mapDispatchToProps)(CheckoutPage);
